import React from 'react';
import { styled } from 'linaria/react';
import { cx } from 'linaria';
import { ReactComponent as MapPinSvg } from '../../svg/MapPin.svg';
import { ReactComponent as MapPinNoNumberSvg } from '../../svg/MapPinNoNumber.svg';
import { theme } from '../Theme';

const MarkerContainer = styled('div')`
  position: relative;
  width: 40px;
  height: 40px;
  /* margin-right: 12px; */

  svg {
    fill: ${theme.colors.accent};
    width: 100%;
    height: 45px;
    padding-top: 6px;
    path {
      stroke: ${theme.colors.accent};
    }
  }
  &.active {
    svg {
      fill: ${theme.colors.white};
    }

    span {
      color: ${theme.colors.white};
    }
  }

  span {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 3px;
    right: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    font-family: 'Source Sans Pro', sans-serif;
    font-size: 12px;
    line-height: 1;

    color: ${theme.colors.accent};
  }
`;

export const StoreMarker = ({ nr, active, large, ...rest }) => (
  <MarkerContainer className={cx(active ? 'active' : null)} {...rest}>
    <MapPinNoNumberSvg />
    {/* <span>{nr}</span> */}
  </MarkerContainer>
);
